import { useConversation, type ActiveFilter } from '../../contexts/ConversationContext';

interface FilterBarProps {
  filters: ActiveFilter[];
}

export default function FilterBar({ filters }: FilterBarProps) {
  const { removeFilter, clearFilters, submitQuery } = useConversation();

  if (filters.length === 0) return null;

  const handleRemoveFilter = (filter: ActiveFilter) => {
    removeFilter(filter.key);
    // Optionally re-query without this filter
    submitQuery(`Show me all items without filtering by ${filter.label.toLowerCase()}`);
  };

  const handleClearAll = () => {
    clearFilters();
    submitQuery('Show me all items');
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {/* Label - hidden on mobile to save space */}
      <span className="hidden sm:inline font-mono text-xs text-grey-medium uppercase tracking-wider">
        Filters:
      </span>

      {/* Filter pills */}
      {filters.map((filter) => (
        <button
          key={filter.key}
          onClick={() => handleRemoveFilter(filter)}
          className="inline-flex items-center gap-1.5 px-2.5 md:px-3 py-1 md:py-1.5 bg-white text-xs md:text-sm text-black font-light border border-grey-medium/30 hover:border-coral hover:bg-coral/5 active:scale-[0.98] transition-all group shadow-subtle"
        >
          <span className="truncate max-w-[120px] md:max-w-none">{filter.label}</span>
          <svg
            className="w-3 h-3 text-grey-medium group-hover:text-coral transition-colors flex-shrink-0"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      ))}

      {/* Clear all button */}
      {filters.length > 1 && (
        <button
          onClick={handleClearAll}
          className="px-2 md:px-3 py-1 text-xs md:text-sm text-coral font-light hover:text-coral/80 hover:underline transition-colors"
        >
          Clear All
        </button>
      )}
    </div>
  );
}
